import { render, staticRenderFns } from "./AdminRightSection.vue?vue&type=template&id=39edb0c7&scoped=true"
import script from "./AdminRightSection.vue?vue&type=script&lang=js"
export * from "./AdminRightSection.vue?vue&type=script&lang=js"
import style0 from "./AdminRightSection.vue?vue&type=style&index=0&id=39edb0c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39edb0c7",
  null
  
)

export default component.exports